import init from './init';
import index from './action_index';
import donors from './action_donors';
import users from './action_users';
import config from './action_config';
import calendar from './action_calendar';
import donorProfile from './action_donor_profile';
import importDonors from './action_donor_import';
import userProfile from './action_user_profile';
import commissionDetail from './action_commission_detail';
import lettera from './action_lettera';

export default {
    init,
    index,
    users,
    donors,
    config,
    calendar,
    userProfile,
    donorProfile,
    importDonors,
    commissionDetail,
    lettera
};